import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { companyInfo } from '../data/mockData';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-800 text-white py-8">
      <div className="max-w-7xl mx-auto px-4">
        {/* Call to Action */}
        <div className="text-center mb-8 py-12 bg-gray-700 rounded-lg">
          <h2 className="text-3xl font-bold mb-4">{t('footer.questionsTitle')}</h2>
          <div className="flex flex-col items-center justify-center space-y-3">
            <div className="flex items-center text-2xl font-bold">
              <Phone className="w-8 h-8 mr-3" />
              <div className="flex flex-col sm:flex-row sm:space-x-4">
                <a href={`tel:${companyInfo.phones[0].replace(/[^0-9]/g, '')}`} className="hover:text-blue-400 transition">
                  {companyInfo.phones[0]}
                </a>
                <a href={`tel:${companyInfo.phones[1].replace(/[^0-9]/g, '')}`} className="hover:text-blue-400 transition">
                  {companyInfo.phones[1]}
                </a>
              </div>
            </div>
            <div className="flex items-center text-lg">
              <Mail className="w-6 h-6 mr-2" />
              <a href={`mailto:${companyInfo.email}`} className="hover:text-blue-400 transition">
                {companyInfo.email}
              </a>
            </div>
          </div>
        </div>

        {/* Contact Information */}
        <div className="grid md:grid-cols-2 gap-6 mb-8 text-center md:text-left">
          <div>
            <div className="flex items-center justify-center md:justify-start mb-2">
              <MapPin className="w-5 h-5 mr-2" />
              <h3 className="font-semibold">{t('footer.serviceAreasTitle')}</h3>
            </div>
            <p className="text-gray-300">{companyInfo.serviceAreas.join(', ')}</p>
            <p className="text-gray-300">{t('footer.location')}</p>
          </div>
          <div>
            <div className="flex items-center justify-center md:justify-start mb-2">
              <Clock className="w-5 h-5 mr-2" />
              <h3 className="font-semibold">{t('footer.hoursTitle')}</h3>
            </div>
            <p className="text-gray-300">{companyInfo.hours}</p>
            {companyInfo.emergency24_7 && (
              <p className="text-green-400 font-semibold mt-1">{t('footer.emergency24_7')}</p>
            )}
          </div>
        </div>

        {/* Footer Logo */}
        <div className="text-center mb-8">
          <img
            src="https://customer-assets.emergentagent.com/job_react-appacific/artifacts/2kicwhna_ap_pacific_footer_logo.png"
            alt="AP Pacific Inc."
            className="h-20 w-auto mx-auto"
          />
        </div>

        {/* Footer Bottom */}
        <div className="text-center text-gray-400 text-sm mt-8 pt-8 border-t border-gray-700">
          <p>{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;